<template>
  <div>
    <el-upload
      action="#"
      accept="image/png,image/jpg,image/jpeg"
      ref="pictureUpload"
      list-type="picture-card"
      :on-change="getFile"
      :auto-upload="false"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove">
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url" alt=""
        >
        <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" :lock-scroll="false">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'publish',
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false
    }
  },
  methods: {
    getFile (file, fileList) {
      this.getBase64(file.raw).then(res => {
        const isLt2M = file.size / 1024 / 1024 < 2
        let src = res
        if (src.indexOf('data:image') > -1 && isLt2M) {
          file.url = res
          this.$emit('fileList', fileList)
          // 是图片  且小于5mb
        } else {
          // 不是图片删除
          for (var i = 0; i < fileList.length; i++) {
            if (fileList[i]['url'] === file.url) {
              fileList.splice(i, 1)
            }
          }
          if (!isLt2M) {
            this.$message.error('图片大小小于2MB')
          } else {
            this.$message.error('请上传图片')
          }
          console.log(file)
        }
      })
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    handleRemove (file) {
      let uploadFiles = this.$refs.pictureUpload.uploadFiles
      for (var i = 0; i < uploadFiles.length; i++) {
        if (uploadFiles[i]['url'] === file.url) {
          uploadFiles.splice(i, 1)
        }
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/upload.vue